import React, { useEffect, useState} from "react";
import {Http} from "../utils/http";
import { Link } from 'react-router-dom';
import {errorMessageForCode} from "../utils/typeResolver";
import { AdvancedSearchQuery } from '../models/AdvancedSearch';
import { AccordionPanel } from "./Helpers";
import { ReCaptcha } from "./Recaptcha";

let previewTimer: any|undefined = undefined;

export const Tagger: React.FC<any> = ({ recordId, context }) => {
  const [tags, setTags] = useState([]);
  const [tagToCreate, _setTagToCreate] = useState('');
  const [createError, setCreateError]: [any, any] = useState(null);
  const [needsRefresh, setNeedsRefresh] = useState(0);
  const [tagPreview, setTagPreview] = useState('');

  const [recaptchaRequired, setRecaptchaRequired] = useState<boolean>(!context.user && !context.captchaVerified);

  useEffect(() => {
    setNeedsRefresh(needsRefresh + 1);
  }, [recaptchaRequired]);

  useEffect(() => {
    Http.get().getTags(recordId).then((json: any) => {
      setTags(json);
    });
  }, [needsRefresh, recordId]);

  const setTagToCreate = (tag: string) => {
    if (!tag) {
      setTagPreview('');
    }

    clearTimeout(previewTimer);

    previewTimer = setTimeout(() => {
      Http.get().previewTag(tag).then((json: any) => {
        if (tagToCreate) {
          setTagPreview(json.tag_preview);
        }
      });
    }, 150);

    _setTagToCreate(tag);
  }

  const addTag = () => {
    if (recaptchaRequired) {
      return;
    }

    setCreateError(null);
    Http.get().addTag(tagToCreate, recordId).then((json: any) => {
      if (json.errors && json.errors.length > 0) {
        if (json.errors[0]['code'] === 'VALIDATION_FAILED') {
          setCreateError(json.errors[0]['validation_code'])
        } else {
          setCreateError([errorMessageForCode(json.errors[0]['code']), json.errors[0]['value'] || ''].join(' '))
        }
      } else {
        setTagToCreate('');
        setNeedsRefresh(needsRefresh + 1);
      }
    })
  };

  const flagTag = (tagId: string) => {
    Http.get().flagTag(tagId).then(() => {
      setNeedsRefresh(needsRefresh + 1);
    });
  };

  const allOfTheTags = () => {
    return (tags.map((tag: any) => (
      <div className="all-tags" key={tag.id}>
        <span className="record-tag">
          <div className="btn-group">
            <Link
              className="qg-btn tag-btn btn-info btn-xs"
              to={{
                pathname: '/search',
                search: AdvancedSearchQuery.emptyQuery().addStickyFilter('tags_string', tag.tag, tag.tag).toQueryString(),
              }}
            >
              <i aria-hidden="true" className="fa fa-tag" />&nbsp;{tag.tag}
            </Link>
            {
              !recaptchaRequired &&
              <>
                <button type="button" className="qg-btn btn-info btn-xs dropdown-toggle"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false">
                        <span className="caret"/>
                  <span className="sr-only">Toggle Dropdown</span>
                </button>
                <ul className="dropdown-menu">
                  <li>
                    {
                      tag.flagged && <span className="text-danger tag-flagged-notice"><i aria-hidden="true" className="fa fa-exclamation-circle" /> Flagged</span>
                    }
                    {
                      !tag.flagged && <button onClick={(e) => {e.preventDefault(); flagTag(tag.id)}} className="qg-btn btn-link text-danger tag-flagged-button"><i aria-hidden="true" className="fa fa-exclamation-circle" /> Flag with Moderator</button>
                    }
                  </li>
                </ul>
              </>
            }
          </div>
        </span>
      </div>
    )))
  }
  
  return (
    <section>
      <h2>User Tags &nbsp; <small><a href="/pages/user-contributions-tagging" rel="noopener noreferrer" target="_blank" aria-label="Information about user contributed tags"><i className="fa fa-question-circle" />&nbsp;More information</a></small></h2>

      <form onSubmit={(e) => {e.preventDefault(); addTag()}}>
        {
          createError &&
          <div className="alert alert-danger">{createError}</div>
        }
        <ReCaptcha context={context} onSuccess={() => setRecaptchaRequired(false)} />
        <div className="form-inline">
          <label className="sr-only" htmlFor="tagger-tag-name">Tag name</label>
          <input id="tagger-tag-name" className="form-control form-control-sm" type="text" value={tagToCreate} onChange={(e) => setTagToCreate(e.target.value)} size={30} maxLength={60} />
          <button className="qg-btn btn-primary btn-sm" type="submit" disabled={recaptchaRequired}>Add Tag</button>
        </div>
      </form>
      {
        tagPreview &&
          <div className="text-muted mt-1">Preview: <span className="badge badge-info"><i aria-hidden="true" className="fa fa-tag" />&nbsp;{tagPreview}</span></div>
      }
      <div>
          {tags.length > 10 ? 
            <>
              {allOfTheTags().slice(0,10)}
                <section className="qg-accordion qg-dark-accordion tag-acc" aria-label="tags"> 
                  <AccordionPanel
                    id={'tag'}
                    anchor="tags"
                    title="More tags">
                    { allOfTheTags().slice(10) }
                  </AccordionPanel>
                </section>
            </>
            : 
            allOfTheTags()
          }
      </div> 
    </section>
  )
}
